import SearchProviders from './SearchProviders';

export default SearchProviders;
